import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Menu(theme: Theme) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          color: 'var(--dk-text-dim, #B7BBC2)',
          background: 'inherit',
          borderRadius: '4px',
          padding: 0,
          marginBottom: '12px',
          '&:last-of-type': {
            marginBottom: 0,
          },
          '&:hover': {
            color: 'var(--dk-text, black)',
          },
          '&.Mui-selected': {
            background: 'transparent',
            color: 'var(--dk-text, black)',
            '&:hover': {
              background: theme.palette.action.hover,
            },
            '&:focus': {
              background: theme.palette.action.hover,
            },
          },
          '&.Mui-disabled': {
            background: 'var(--dk-bg-subtle, #F9FAFB)',
            borderColor: 'var(--dk-line, #E7E9EC)',
            color: 'var(--dk-text-disabled, #D1D8E2)',
          },
        },
      },
    },
  };
}
